/**
 * Utility for extracting clean note titles from file paths
 * Auto-detects file extensions and removes them to get the note title
 */

/**
 * Extracts a clean note title from a file path by removing the file extension
 * @param path - The file path (e.g., "folder/note.md" or "note.markdown")
 * @returns The note title without extension (e.g., "note")
 */
export function noteTitleFromPath(path: string): string {
  // Get the filename from the path
  const filename = path.split('/').pop() ?? path
  
  // Find the last dot to identify the extension
  const lastDotIndex = filename.lastIndexOf('.')
  
  // If no extension found, return the filename as-is
  if (lastDotIndex === -1) {
    return filename
  }
  
  // Return filename without extension
  return filename.slice(0, lastDotIndex)
}
